export function nonBreakHypens(text) {
  return text.replace(/-/g, '‑')
}
